import React from 'react';
import { FormField } from '../../../components/FormField';
import { FormRow } from '../../../components/FormRow';
import { kitchenTypes } from '../../../constants/propertyOptions';
import { formatArea } from '../../../../../../utils/formatters';

interface RoomsProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

export const Rooms: React.FC<RoomsProps> = ({
  formData,
  handleInputChange,
}) => {
  // Gestionnaire pour les champs de surface (supprime les décimales)
  const handleAreaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    // Supprimer tout sauf les chiffres
    const numericValue = value.replace(/[^\d]/g, '');
    
    handleInputChange({
      target: {
        name,
        value: numericValue,
        type: 'text'
      }
    } as React.ChangeEvent<HTMLInputElement>);
  };
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white">
        2. Pièces
      </h3>

      <FormRow>
        <FormField label="Nombre de pièces">
          <input
            type="number"
            name="roomCount"
            value={formData.roomCount || ''}
            onChange={handleInputChange}
            min="1"
          />
        </FormField>

        <FormField label="Nombre de chambres">
          <input
            type="number"
            name="bedroomCount"
            value={formData.bedroomCount || ''}
            onChange={handleInputChange}
            min="0"
          />
        </FormField>
      </FormRow>

      <FormRow>
        <FormField label="Type de cuisine">
          <select
            name="kitchenType"
            value={formData.kitchenType || ''}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            {kitchenTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </FormField>

        <FormField label="Nombre de salles de bain">
          <input
            type="number"
            name="bathroomCount"
            value={formData.bathroomCount || ''}
            onChange={handleInputChange}
            min="0"
          />
        </FormField>
      </FormRow>
    </div>
  );
};